import React, {use, useEffect, useRef, useState} from 'react'
import styles from './skillActivityStatus.module.scss'

import SelectField from '../Field/SelectField'
import Spinner from 'Components/Feedback/Spinner'

import API from 'Class/API'

export const SkillActivityStatus = ({
    activity,
    community,
    className = '',
    flip: flipInput = false,
    getTranslation = () => {},
    label = '',
    onChange = () => {},
    status: inputStatus
}) =>
{
    const [flip, setFlip] = useState(!!flipInput)
    const [loading, setLoading] = useState(false)
    const [status, setStatus] = useState(inputStatus)
    const wrapper = useRef(null)
    const isMounted = useRef(true)
    const statuses = ['not_started', 'started', 'paused', 'completed']
    const options = {}

    statuses.forEach(status => {
        options[status] = getTranslation(`status_${status}`)
    })

    const getStatus = async () =>
    {
        if (!isMounted.current)
        {
            return
        }

        setLoading(true)
        const {current_status} = await API.RequestAsync('skillActivities/status',
        {
            activity,
            community
        })

        if (!isMounted.current)
        {
            return
        }
        
        setLoading(false)
        setStatus(current_status || 'not_started')
    }

    const updateStatus = async (_, newStatus) =>
    {
        const oldStatus = status
        setLoading(true)
        setStatus(newStatus)
        const {error} = await API.RequestAsync('skillActivities/status',
        {
            activity,
            community,
            status: newStatus
        })
        if (!isMounted.current) return
        setLoading(false)
        if (error)
        {
            setStatus(oldStatus)
        }
        else
        {
            onChange(newStatus)
        }
    }

    useEffect(() => () => { isMounted.current = false }, [])
    useEffect(() => { inputStatus ? setStatus(inputStatus) : getStatus() }, [activity, community, inputStatus])

    useEffect(() => {
        if (!wrapper.current)
        {
            return
        }
        if (typeof flipInput?.addEventListener !== 'function')
        {
            setFlip(!!flipInput)
            return
        }
        flipInput.addEventListener('scroll', () =>
        {
            const {y: wrapperOffset, height} = flipInput.getBoundingClientRect()
            const {y: fieldOffset} = wrapper.current.getBoundingClientRect()
            const bottomOffset = wrapperOffset + height - fieldOffset
            setFlip(bottomOffset < height / 2)
        })
    }, [flipInput, wrapper])

    return (
        <div
            className={[styles.status, styles[status], className].filter(c => !!c).join(' ')}
            ref={wrapper}
        >
            {label && <span className={styles.label}>{label}</span>}
            <SelectField
                className={styles.field}
                disabled={loading}
                flip={flip}
                onChange={updateStatus}
                options={options}
                value={status}
            />
            {loading && <Spinner size={20}/>}
        </div>
    )
}

export default SkillActivityStatus